import { getOffsetsRepository, patchManageDataRepository } from "../Infrastructure/DashboardOffset.repository";

export async function getOffsetsLogic(id) {
  return getOffsetsRepository(id);
}
export async function patchManageDataLogic(id, params) {
  return patchManageDataRepository(id, params);
}
